import { Fade } from "react-awesome-reveal";
import Footer from "./Footer";
import Header from "./Header";
const Job = () => {
    const elements = [
        "Dobór odpowiedniego sprzętu zgodnie z potrzebami użytkownika wraz z kontaktem z firmą, firmami dostarczającymi odpowiednie wyposażenie medyczne z gwarancją uzyskania najkorzystniejszej ceny.",
        "Rozpisanie przetargu, tak aby postępowanie przetargowe odbyło się bez powtórzeń, a zapisy w specyfikacji nie budziły wątpliwości podczas kontroli.",
        "Obecność podczas narad, odpraw, jeżeli kupowane sprzęty będą wchodziły w część budowlaną lub jeśli taka obecność będzie wymagana przez Klienta.",
        "Sprawdzenie specyfikacji zgodnie z materiałami dostarczonymi od wykonawcy oraz napisanie ewentualnego wezwania do Wykonawcy.",
        "Napisanie pism przewodnich do jednostek wspierających szpitale, kliniki w dofinansowaniu.",
        "Rozpisanie programów ministerialnych.",
        "Pomoc przy tworzeniu umów zakupowych, tak aby zawierały wszystkie niezbędne pozycje, które pozwolą uniknąć dodatkowych kosztów w czasie trwania gwarancji.",
        "Stały kontakt i wsparcie po zakończonych projektach.",
    ];

    return (
        <div className="job">
            <Fade className="fade_header" duration={2000}>
                <Header />
            </Fade>
            <div className="job_main">
                <div className="job_text">
                    <div className="job_intro_copy">
                        <span className="job_kicker">OFERTA WSPÓŁPRACY</span>
                        <h2>Wsparcie w projektach medycznych</h2>
                        <p>
                            Jeśli potrzebują Państwo kompleksowego wsparcia,
                            zapraszam do współpracy – przy pojedynczym zadaniu
                            lub projekcie realizowanym długofalowo. Pomagam
                            przejść przez proces zakupowy i organizacyjny,
                            dbając o rzetelność, korzystne warunki i kontrolę
                            kosztów.
                        </p>
                        <a className="job_cta" href="#job_offer">
                            Poznaj zakres wsparcia <span aria-hidden="true">↓</span>
                        </a>
                    </div>
                    <div className="job_img" role="img" aria-label="Wyposażenie placówki medycznej" />
                </div>

                <section className="job_offer" id="job_offer" aria-labelledby="job_offer_heading">
                    <div className="job_offer_intro">
                        <span className="job_kicker">JAK MOGĘ POMÓC</span>
                        <h2 id="job_offer_heading">Zakres wsparcia</h2>
                    </div>
                    {elements.map((item, index) => (
                        <article key={index} className="job_item">
                            <span className="job_number">
                                {String(index + 1).padStart(2, "0")}
                            </span>
                            <p>{item}</p>
                        </article>
                    ))}
                </section>

                <p className="p_footer">
                    Moja oferta skierowana jest do placówek medycznych
                    państwowych oraz prywatnych, domów seniora, opieki
                    medycznej, hospicjów itp., a także do firm budowlanych oraz
                    projektowych, które potrzebują wsparcia w zakresie doboru
                    sprzętu medycznego a podjęli się kompleksowego wykonania
                    projektu.
                </p>
            </div>
            <Footer />
        </div>
    );
};
export default Job;
